import _styled from "styled-components";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { hasItems } from "~/features/app/utils";
import { FooterSocial } from "~/features/app/app-footer/footer-socials/footer-social";
const fragment = graphql(`
  fragment FooterSocials on footerSocials_NeoField {
    ...FooterSocial
  }
`);
type Props = {
  socials: FragmentType<typeof fragment>[];
};
export function FooterSocials(props: Props) {
  const {
    socials
  } = props;
  const items = useFragment(fragment, socials);
  if (!hasItems(socials)) {
    return null;
  }
  return <_StyledUl>
      {items.map((social, idx) => <li key={idx}>
          <FooterSocial {...social} />
        </li>)}
    </_StyledUl>;
}
var _StyledUl = /*#__PURE__*/_styled("ul").withConfig({
  displayName: "footer-socials___StyledUl",
  componentId: "sc-fenurn-0"
})({
  "display": "flex",
  "width": "100%",
  "justifyContent": "center",
  "gap": "6.4rem",
  "@media (min-width: 1024px)": {
    "gap": "4.8rem"
  }
});